import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-20-kartikey-hariyani-guest.webp";
import ThumbImg from "../../assets/images/conversations/020.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: kh2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .kh2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .kh2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .kh2-hero { padding-top: 60px; padding-bottom: 60px; }
  .kh2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .kh2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .kh2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kh2-hero__title.kh2-visible { opacity: 1; transform: translateY(0); }
  .kh2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .kh2-hero__spotify.kh2-visible { opacity: 1; transform: translateY(0); }
  .kh2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .kh2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .kh2-hero__right.kh2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .kh2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .kh2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .kh2-yt-thumb:hover img { opacity: 0.85; }
  .kh2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .kh2-yt-thumb__play img { width: 40px; height: 44px; }
  .kh2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .kh2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .kh2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kh2-body.kh2-visible { opacity: 1; transform: translateY(0); }
  .kh2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .kh2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .kh2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kh2-guest.kh2-visible { opacity: 1; transform: translateY(0); }
  .kh2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .kh2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .kh2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .kh2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .kh2-inner { padding-left: 32px; padding-right: 32px; }
    .kh2-hero { padding-top: 32px; padding-bottom: 48px; }
    .kh2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .kh2-hero__title { font-size: 24px; }
    .kh2-hero__left { gap: 16px; }
    .kh2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .kh2-guest__photo-bg { width: 260px; height: 300px; }
    .kh2-guest__name { font-size: 24px; margin-top: 18px; }
    .kh2-body__para { font-size: 14px; margin-bottom: 12px; }
    .kh2-body { padding-bottom: 48px; }
    .kh2-guest { padding-bottom: 48px; }
    .kh2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .kh2-inner { padding-left: 16px; padding-right: 16px; }
    .kh2-hero { padding-top: 51px; padding-bottom: 30px; }
    .kh2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .kh2-hero__left { gap: 30px; }
    .kh2-hero__title { font-size: 30px; }
    .kh2-body__para { font-size: 16px; margin-bottom: 10px; }
    .kh2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .kh2-guest__photo-bg { width: 100%; height: 386px; }
    .kh2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .kh2-body { padding-bottom: 30px; }
    .kh2-guest { padding-bottom: 30px; }
    .kh2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("kh2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "rh6St6xSmkA";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="kh2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 20 Kartikey Hariyani Chargezone"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="kh2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 20 Kartikey Hariyani thumbnail" />
      <div className="kh2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="kh2-hero">
      <div className="kh2-inner">
        <div className="kh2-hero__grid">
          <div className="kh2-hero__left">
            <h1 ref={titleRef} className="kh2-hero__title">
              EP 20 | Electrifying Indian Highways | Kartikey Hariyani | Chargezone
            </h1>
            <div ref={spotifyRef} className="kh2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/7DrvIkIWRv3Ie4EHwbHivT?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 20 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="kh2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="kh2-body">
      <div className="kh2-inner">
        <p className="kh2-body__para">
          Unlike ICE vehicles, where the ecosystem was built over the last 100 years, the Electric Vehicle sector is still waiting for all parts of the ecosystem to talk to each other. Until that happens EV drivers and fleet owners will not have a seamless mobility experience. We often hear of the concept of range anxiety, in order to address this we don't just need more chargers or charging stations on the road, instead, the entire ecosystem will need to dance in harmony for the end-user, the power grid, the charging infrastructure, the charging protocol and standards that are implemented, ChargePoint operations the possibility of customers roaming between CPO's and then, of course, the GSM connectivity and paywall software operations.
        </p>
        <p className="kh2-body__para">
          We have a chicken and egg conundrum today in India with each part of the ecosystem making leaps forward, but in isolation rather than in harmony. Having said that an important layer addressing range anxiety today is in fact the size and the reliability of the ChargePoint Operator. The CPO sector has seen a significant amount of investment in the last 12 months in India, with numerous fast-charging stations being installed around the highways in the country. This is just the beginning, the best is yet to come.
        </p>
        <p className="kh2-body__para">
          Today we welcome back the CEO of one such ChargePoint Operator Kartikey Hariyani, Managing Director of ChargeZone, who has visited our studios only a year ago but today manages a business that is radically different from the one we have examined at that time.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="kh2-guest">
      <div className="kh2-inner">
        <h2 className="kh2-guest__title">Our Guest</h2>
        <div>
          <div className="kh2-guest__photo-bg">
            <img src={GuestImg} alt="Kartikey Hariyani" />
          </div>
          <p className="kh2-guest__name">Kartikey HARIYANI</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep20KartikeyHariyani() {
  return (
    <>
      <style>{CSS}</style>
      <div className="kh2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}